import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dialog-avviso',
  templateUrl: './avviso.component.html',
  styleUrls: ['./avviso.component.scss']
})
export class AvvisoComponent implements OnInit {
  title: string;
  message: string;
  constructor(public dialogRef: MatDialogRef<AvvisoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
